<template>
  <div class="userInfo">
    <div class="tips" id="tips"></div>
    <van-form v-if="loginTrue" validate-first @submit="onSubmit">
      <van-field
        v-model="username"
        name="姓名"
        label="姓名"
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写正确姓名' }]"
      />
      <van-field
        v-model="sex"
        name="性别"
        label="性别"
        placeholder="性别"
        readonly
        @click="showPickerBottom('sex')"
        :rules="[{ required: true, message: '请选择性别' }]"
      />
      <van-field
        v-model="age"
        type="number"
        maxlength="3"
        name="年龄"
        label="年龄"
        placeholder="年龄"
        :rules="[{ required: true, pattern, message: '请填写正确格式年龄' }]"
      />
      <van-field
        v-model="work"
        name="工作情况"
        label="工作情况"
        placeholder="工作情况"
        readonly
        @click="showPickerBottom('work')"
        :rules="[{ required: true, message: '请选择工作情况' }]"
      />
      <van-field
        v-model="address"
        name="地区"
        label="地区"
        placeholder="地区"
        readonly
        @click="showPickerBottom('address')"
        :rules="[{ required: true, message: '请选择地区' }]"
      />
      <van-field
        v-model="nation"
        name="民族"
        label="民族"
        placeholder="民族"
        :rules="[{ required: false, message: '请填写民族' }]"
      />
      <van-field
        v-model="liveAlone"
        name="是否独居"
        label="是否独居"
        placeholder="是否独居"
        readonly
        @click="showPickerBottom('liveAlone')"
        :rules="[{ required: false, message: '请选择是否独居' }]"
      />
      <van-field
        v-model="education"
        name="文化程度"
        label="文化程度"
        placeholder="文化程度"
        readonly
        @click="showPickerBottom('education')"
        :rules="[{ required: false, message: '请选择文化程度' }]"
      />
      <van-field
        v-model="economics"
        name="经济情况"
        label="经济情况"
        placeholder="经济情况"
        readonly
        @click="showPickerBottom('economics')"
        :rules="[{ required: false, message: '请选择经济情况' }]"
      />
      <van-field
        v-model="marriage"
        name="婚姻状况"
        label="婚姻状况"
        placeholder="婚姻状况"
        readonly
        @click="showPickerBottom('marriage')"
        :rules="[{ required: false, message: '请选择婚姻状况' }]"
      />
      <van-field
        v-model="pressure"
        name="压力来源"
        label="压力来源"
        placeholder="压力来源"
        readonly
        @click="showPickerBottom('pressure')"
        :rules="[{ required: false, message: '请选择压力来源' }]"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        :title="title"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
    <div class="back" v-if="isAndroid && loginTrue" @click="backHome">返回</div>
    <Login v-if="loginTk" />
    <ChoiceCompany
      :choiceTk="choiceTk"
      :mobile="mobile"
      :companyList="companyList"
      v-if="choiceTk"
    />
  </div>
</template>
<script>
import serivce from "@/utils/ajax";
import ChoiceCompany from "./components/choiceCompany.vue";
import Login from "./components/login.vue";
export default {
  components: {
    Login,
    ChoiceCompany,
  },
  data() {
    return {

      loginTk: false,
      mobile: "",
      companyList: [],
      choiceTk: false,

      username: "",
      sex: "",
      age: "",
      title: "",
      work: "",
      address: "",
      nation: "",
      liveAlone: "",
      education: "",
      economics: "",
      marriage: "",
      pressure: "",
      pattern: /^(1|([1-9]\d{0,1})|100)$/,
      // 下拉框
      showPicker: false,
      types: "",
      columns: [],

      phone: "",
      companyId: "",
      isAndroid: false,
      loginTrue:true
    };
  },
  created(){
    if(this.$route.query.app_secret){
      sessionStorage.setItem("app_secret", this.$route.query.app_secret)
      localStorage.setItem("userInfo", this.$route.query.userInfo)
      
    }
  },
  mounted() {
    var u = navigator.userAgent;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    
    if(sessionStorage.getItem("loginTk") && sessionStorage.getItem("loginMsg")){
      this.loginTk = sessionStorage.getItem("loginTk")
    }
    document.title = this.$route.query.from;
    if (
      !localStorage.getItem("IntegratedTitle") ||
      !localStorage.getItem("userInfo")
    ) {
      localStorage.setItem("IntegratedTitle", this.$route.query.from);
      this.loginTk = true;
      this.loginTrue = false
    } else {
      this.getList();
    }
    if(this.$route.query.app_secret){
      this.getList()
      this.isAndroid = false
    }
  },
  methods: {
    backHome() {
      // this.$router.push({
      //   path: "/IntegratedMy?title=" + this.$route.query.from,
      // });
    },
    tabCompany(companyList, phone) {
      this.mobile = phone;
      this.companyList = companyList;
      this.choiceTk = true;
    },
    getList() {
      this.loginTrue = true
      this.loginTk = false
      this.choiceTk = false
      if (localStorage.getItem("userInfo")) {
        this.companyId = JSON.parse(localStorage.getItem("userInfo")).companyId;
        this.phone = JSON.parse(localStorage.getItem("userInfo")).phone;
      }
      let datas = {
        phone: this.phone,
        companyId: this.companyId,
      };
      serivce.get(`/sp_api/spUser/view`, datas).then((res) => {
        if (res.code == 0) {
          this.username = res.data.name;
          this.work = res.data.workStatus;
          this.age = res.data.age;
          this.sex = res.data.sex;
          this.address = res.data.area;
          this.nation = res.data.nation;
          this.liveAlone = res.data.liveStatus;
          this.education = res.data.education;
          this.economics = res.data.economy;
          this.marriage = res.data.marryStatus;
          this.pressure = res.data.pressureSource;
        } else {
          this.pupUp(res.msg);
        }
      });
    },
    onSubmit(values) {
      let datas = {
        phone: this.phone,
        companyId: this.companyId,
        name: this.username,
        workStatus: this.work,
        age: this.age,
        sex: this.sex,
        area: this.address,
        nation: this.nation,
        liveStatus: this.liveAlone,
        education: this.education,
        economy: this.economics,
        marryStatus: this.marriage,
        pressureSource: this.pressure,
      };
      serivce.post(`/sp_api/spUser/update`, datas).then((res) => {
        if (res.code == 0) {
          this.pupUp(res.msg);
          setTimeout(() => {
            this.backHome();
          }, 1500);
        } else {
          this.pupUp(res.msg);
        }
      });
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    onConfirm(val) {
      if (this.types == "sex") {
        this.sex = val;
      }
      if (this.types == "work") {
        this.work = val;
      }
      if (this.types == "address") {
        this.address = val;
      }
      if (this.types == "liveAlone") {
        this.liveAlone = val;
      }
      if (this.types == "education") {
        this.education = val;
      }
      if (this.types == "economics") {
        this.economics = val;
      }
      if (this.types == "marriage") {
        this.marriage = val;
      }
      if (this.types == "pressure") {
        this.pressure = val;
      }
      this.columns = [];
      this.title = "";
      this.showPicker = false;
    },
    onCancel(val) {
      this.columns = [];
      this.title = "";
      this.showPicker = false;
    },
    showPickerBottom(types) {
      this.types = types;
      if (this.types == "work") {
        this.columns = ["在职", "失业", "退休"];
        this.title = "工作情况";
      }
      if (this.types == "sex") {
        this.columns = ["男", "女"];
        this.title = "性别";
      }
      if (this.types == "address") {
        this.columns = ["城市", "农村"];
        this.title = "地区";
      }
      if (this.types == "liveAlone") {
        this.columns = ["是", "否"];
        this.title = "是否独居";
      }
      if (this.types == "education") {
        this.columns = [
          "高中以下",
          "高中",
          "大专",
          "本科",
          "硕士研究生",
          "博士研究生",
        ];
        this.title = "文化程度";
      }
      if (this.types == "economics") {
        this.columns = [
          "月收入<1000",
          "月收入1000-3000",
          "月收入3000-5000",
          "月收入5000-10000",
          "月收入>10000",
          "保密",
        ];
        this.title = "经济情况";
      }
      if (this.types == "marriage") {
        this.columns = ["未婚", "已婚", "离异", "丧偶", "保密"];
        this.title = "婚姻情况";
      }
      if (this.types == "pressure") {
        this.columns = ["经济", "工作", "学习", "情感", "孩子", "其他"];
        this.title = "压力来源";
      }
      this.showPicker = true;
    },
  },
};
</script>
<style lang="less" scoped>
.back {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.8rem;
  // padding: 0.2rem 0.3rem;
  background: #f7f7f7;
  line-height: 0.8rem;
  font-size: 0.32rem;
  // padding-left: 0.4rem;
  text-align: center;
}
</style>
<style lang="less">
.userInfo .van-radio__icon {
  display: inline-block;
  float: left;
}
</style>